require('ta-semantic-ui/semantic/dist/components/card.css');
require('ta-semantic-ui/semantic/dist/components/modal.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/image.css');

import React from 'react'

import List from '../list/List'

const propTypes = {
  data: React.PropTypes.array.isRequired
  };

const CardsContainer = (props) => {

  return (
    <div className="ui three stackable cards">
        {
          props.data.map((item, index) => {
            return <List key={index} itemData={item} />
          })
        }
    </div>
    )
}

List.propTypes = propTypes

export default CardsContainer


// WEBPACK FOOTER //
// ./src/components/custom/cardsContainer/CardsContainer.js